import React from "react";
import { Box, Button, Divider } from "@mui/material";
import { ReactComponent as ShareIcon } from "../../assets/icons/share.svg";
import CloseIcon from "../VectorIcons/CloseIcon";
import ReleaseTextIcon from "../VectorIcons/ReleaseTextIcon";

const baseButtonSx = {
  fontFamily: "Globotipo Text",
  textTransform: "none",
  fontWeight: "bold",
  px: "16px",
  fontSize: "16px",
  height: "46px",
};

const outlinedButtonSx = {
  ...baseButtonSx,
  color: "#7F808E",
  borderColor: "#7F808E",
  "&:hover": {
    borderColor: "#7F808E",
    backgroundColor: "rgba(127,128,142,0.08)",
  },
  "&.Mui-disabled": {
    color: "#7F808E",
    borderColor: "#E2E4FF",
  },
};

const containedButtonSx = {
  ...baseButtonSx,
  color: "#7F808E",
  borderColor: "#E2E4FF",
  boxShadow: "none",
  "&:hover": {
    boxShadow: "none",
    backgroundColor: "rgba(127,128,142,0.08)",
  },
  "&.Mui-disabled": {
    color: "#7F808E",
  },
};

/**
 * Selection-mode action row (Cancelar / count / Compartilhar / Liberação).
 * Extracted from ModalActionsFooter so it can be reused by consumers that
 * don't want the sticky/floating Paper wrapper (e.g. UploadBox).
 */
const SelectionActionsBar = ({
  selectedCount = 0,
  onCancel,
  onShare,
  onRelease,
  canShare = false,
  canRelease = false,
  outlineEnabledButtons = false,
}) => {
  const hasSelection = selectedCount > 0;
  const canReleaseSelection = hasSelection && canRelease;
  const activeTextColor = hasSelection ? "#575863" : "#7F808E";
  const activeBackgroundColor = hasSelection ? "#FFF" : "transparent";
  const activeBorder =
    outlineEnabledButtons && hasSelection ? "1px solid #E2E4FF" : "none";
  const releaseActiveTextColor = canReleaseSelection ? "#575863" : "#7F808E";
  const releaseActiveBackgroundColor = canReleaseSelection
    ? "#FFF"
    : "transparent";
  const releaseActiveBorder =
    outlineEnabledButtons && canReleaseSelection ? "1px solid #E2E4FF" : "none";
  const selectedMessage =
    selectedCount === 1
      ? `${selectedCount} item selecionado`
      : `${selectedCount} itens selecionados`;

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "24px",
          mr: "24px",
        }}
      >
        <Button
          variant="outlined"
          onClick={onCancel}
          startIcon={<CloseIcon color="#7F808E" size={24} />}
          sx={outlinedButtonSx}
        >
          Cancelar
        </Button>

        <Divider
          orientation="vertical"
          flexItem
          sx={{ borderColor: "#7F808E" }}
        />

        <Box
          component="span"
          sx={{ fontSize: "16px", color: "#575863", whiteSpace: "nowrap" }}
        >
          {selectedMessage}
        </Box>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", gap: "24px" }}>
        {canShare && (
          <Button
            variant="contained"
            onClick={onShare}
            disabled={!hasSelection}
            startIcon={<ShareIcon />}
            sx={{
              ...containedButtonSx,
              "& svg path": {
                fill: activeTextColor,
              },
              color: activeTextColor,
              backgroundColor: activeBackgroundColor,
              border: activeBorder,
            }}
          >
            Compartilhar
          </Button>
        )}

        {canRelease && (
          <Button
            variant="contained"
            onClick={onRelease}
            disabled={!hasSelection}
            startIcon={
              <ReleaseTextIcon color={hasSelection ? "#1E9F69" : "#7F808E"} />
            }
            sx={{
              ...containedButtonSx,
              color: releaseActiveTextColor,
              backgroundColor: releaseActiveBackgroundColor,
              border: releaseActiveBorder,
            }}
          >
            Liberação
          </Button>
        )}
      </Box>
    </>
  );
};

export default React.memo(SelectionActionsBar);
